<template>
  <div id="homes">
    <div id="homeSwiper" class="swiper-container swiper-container-my">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-no-swiping" v-for="item in tempdata">
          <img :src="item.imageUrl" alt="" @click="ifturntonewpage(item.id,item.hyperlink)">
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination homePagination"></div>
      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev homeSwiperPre"></div>
      <div class="swiper-button-next homeSwiperNext"></div>
    </div>
  </div>

</template>

<script>
  var _this;
  import Swiper from 'swiper';

  export default {
    name: 'home',
    data() {
      return {
        msg: '首页',
        tempdata: [],
      }
    },

    //监听
    watch: {},

    //事件处理
    methods: {
      initSwiper: function () {
        var mySwiper = new Swiper('#homeSwiper', {
          loop: true,
          autoplay: {
          	delay: 4000,
            disableOnInteraction: false,
          },
          speed: 1000,
          observer: true,
          observeParents: true,
          pagination: {
            el: '.homePagination',
            clickable: true,
            clickableClass: 'homePagination',
          },
          navigation: {
            nextEl: '.homeSwiperNext',
            prevEl: '.homeSwiperPre',
          },

        })

      },
      requestbanner: function (offset) {
        this.request.get({
          url: '/ad/banner',
          params: {},
          callback: function (data) {
            this.tempdata = data.data;
            if (this.tempdata.length == 0) return;
            setTimeout(function () {
              this.initSwiper()
            }.bind(this), 0)

          }.bind(this)
        })
      },
      ifturntonewpage: function (num, hashLinkNum) {
        window.open(hashLinkNum)

      },
    },

    //实例加载完成后
    created() {
      _this = this;
      this.requestbanner();
    },

    //页面完成以后
    mounted: function () {
    },
  }
</script>

<style>
  #homes {
    height: 600px;
    width: 100%;
  }

  .swiper-container-my {
    width: 100%;
    height: 600px;
  }

  .swiper-container-my .swiper-pagination .swiper-pagination-bullet {
    border-radius: 5px;
    width: 40px;
    background-color: white;
     cursor: pointer;
  }

 .swiper-container-my .swiper-button-prev {
    background-image: url("../images/icon/ban_pre.png");
    background-size: cover;
    height: 110px;
    width: 40px;
    margin-left: 80px;
  }

  .swiper-container-my .swiper-button-next {
    background-image: url("../images/icon/ban_next.png");
    background-size: cover;
    height: 110px;
    width: 40px;
    margin-right: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home.vue